import { render, staticRenderFns } from "./countTitle.vue?vue&type=template&id=2d4819b8&scoped=true"
import script from "./countTitle.vue?vue&type=script&lang=js"
export * from "./countTitle.vue?vue&type=script&lang=js"
import style0 from "./countTitle.vue?vue&type=style&index=0&id=2d4819b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4819b8",
  null
  
)

export default component.exports